<template>
    <div>
        <!-- Begin Page Content -->
        <div class="medical-records doctor-list">
            <div class="row">
                <div class="col-12 mb-4">
                    <div class="card border-0">
                        <div class="card-body profile-details bg-white border-radius-5">
                            <figure class="mb-0"><img src="../../../../static/website/images/video-call-image.png" class="Appointment" alt="Appointment-image" /></figure>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- End of Page Wrapper -->
    </div>
</template>
<script>
    export default {
        name: "start-appointment",
        data() {
            return {};
        },
        created(){
           this.pageName('Appointment')
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/website/appointments/start-appointment.vue